// extracted by mini-css-extract-plugin
module.exports = {"footer":"cw_qr","footer__line":"cw_qs","footer__copyright":"cw_qt"};